import clsx from "clsx";
import React from "react";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import {
  withClickBlocker,
  WithClickBlockerProps
} from "components/BlockableClickContext";
import { useExamLockerContext } from "components/ExamLockerContext/ExamLockerContext";
import { useLoggedInUser } from "components/LoggedInUserProvider";
import { useComplicatedRolesAndStatuses } from "hooks/useComplicatedRolesAndStatuses";
import ActionCellCheckbox from "../ActionCellCheckbox";

import useStyles from "./styles";

interface IProps {
  examStatus: racehorse360.HorseExamStatus;
  isAssignChecked: boolean;
  assignedUserId: string;
  isLoading: boolean;
  onAssignChange: (value: boolean) => void;
}

const AssignActionCell: React.FC<IProps & WithClickBlockerProps> = props => {
  const {
    examStatus,
    isAssignChecked,
    assignedUserId,
    isLoading,
    onAssignChange,
    handleBlockableClick
  } = props;

  const classes = useStyles();
  const { isLocked } = useExamLockerContext();
  const { isCurrentUserChiefOrSeniorVet, isCurrentUserAssigned } =
    useComplicatedRolesAndStatuses({
      assignedUserId
    });
  const {
    currentUser: { isTrackVet }
  } = useLoggedInUser();

  const isExamStatusInProgress =
    examStatus === racehorse360.HorseExamStatus.HORSE_EXAM_STATUS_IN_PROGRESS;

  const isCheckBoxEnabled =
    (isTrackVet && !isExamStatusInProgress && !isCurrentUserAssigned) ||
    (isCurrentUserChiefOrSeniorVet && !isLocked);

  const handleAssignCheckChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    handleBlockableClick(() => {
      const checked = event.target.checked;

      onAssignChange(checked);
    });
  };

  return (
    <ActionCellCheckbox
      className={clsx({ [classes.assignCheckboxChecked]: isAssignChecked })}
      checked={isAssignChecked}
      isLoading={isLoading}
      disabled={!isCheckBoxEnabled}
      onChange={handleAssignCheckChange}
      dataTestId={"assignCheckbox"}
    />
  );
};

export default withClickBlocker<IProps>(React.memo(AssignActionCell));
